import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileBookingBar, useIsMobile } from "@/components/booking/BookingBar";

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
};

/** Pages whose first screen is a full-bleed photo – the header sits transparent on top of it */
const PHOTO_HERO_PAGES = ["/rom", "/mat", "/arrangement", "/praktisk", "/om-oss"];

export const SiteLayout = () => {
  const { pathname } = useLocation();
  const isMobile = useIsMobile();
  const bookingFlow = pathname.startsWith("/bestill") || pathname.startsWith("/mi-bestilling");
  const showSearch = pathname === "/" || pathname === "/rom";
  // Home is full-bleed on desktop only (phones get copy-on-white first), content pages always
  const overlay = (pathname === "/" && !isMobile) || PHOTO_HERO_PAGES.includes(pathname);
  return (
    <div className="min-h-screen bg-background">
      <Header showSearch={showSearch} overlay={overlay} />
      <main className={overlay ? "" : "pt-16 lg:pt-[72px]"}>
        <Outlet />
      </main>
      <Footer compact={bookingFlow} />
      {!bookingFlow && <MobileBookingBar />}
    </div>
  );
};
